export default "__VITE_ASSET__Cppj0R9m__"